import React from 'react';
import PropTypes from 'prop-types';

import Icon from './icon';

const PlayButton = (props) => {
    const { className, ...safeProps } = props;
    return (
        <button
            {...safeProps}
            className={`play-button ${className}`}
            aria-label="Play">
            <Icon name="play" />
        </button>
    );
};

PlayButton.propTypes = {
    className: PropTypes.string,
};

PlayButton.defaultProps = {
    className: '',
};

export default PlayButton;
